export const Messages = {
  requestAssistanceSuccess: 'Your request has been successfully submitted!'
};
